module.exports = __webpack_public_path__ + "img/tutorial_doubts_01.829b1589.gif";